// Camp sub-options for hotels that host more than one bookable camp
// under the same parent slug. Keeps the booking widget aware of the
// La Belle Étoile Bivouacs 3-camp structure without pulling in the
// full hotelDetails module (which is large). Camp slugs mirror those
// in `hotelDetails.js` so downstream code can still look them up.

export const CAMPS_BY_HOTEL = {
  "la-belle-etoile-bivouacs": [
    {
      slug: "bivouac-la-belle-etoile",
      label: {
        en: "Bivouac La Belle Étoile",
        fr: "Bivouac La Belle Étoile",
        es: "Bivouac La Belle Étoile",
      },
      short: {
        en: "Traditional",
        fr: "Traditionnel",
        es: "Tradicional",
      },
    },
    {
      slug: "luxury-desert-camp",
      label: {
        en: "Bivouac La Belle Étoile Luxe",
        fr: "Bivouac La Belle Étoile Luxe",
        es: "Bivouac La Belle Étoile Luxe",
      },
      short: {
        en: "Luxe",
        fr: "Luxe",
        es: "Luxe",
      },
    },
    {
      slug: "luxury-desert-camp-mini",
      label: {
        en: "Bivouac La Belle Étoile Mini",
        fr: "Bivouac La Belle Étoile Mini",
        es: "Bivouac La Belle Étoile Mini",
      },
      short: {
        en: "Mini",
        fr: "Mini",
        es: "Mini",
      },
    },
  ],
};

export const getCampsForHotel = (slug) => CAMPS_BY_HOTEL[slug] || [];

export const getCampLabel = (hotelSlug, campSlug, lang = "en") => {
  const camps = getCampsForHotel(hotelSlug);
  const camp = camps.find((c) => c.slug === campSlug);
  if (!camp) return "";
  return camp.label[lang] || camp.label.en || "";
};

// Return the array of pretty labels for a list of camp slugs, in the
// same order as the source `campSlugs` array. Falls back to an empty
// string when a slug can't be resolved.
export const getCampLabels = (hotelSlug, campSlugs, lang = "en") => {
  if (!Array.isArray(campSlugs) || campSlugs.length === 0) return [];
  return campSlugs.map((s) => getCampLabel(hotelSlug, s, lang)).filter(Boolean);
};

// Return the concatenated short labels joined by " · " for compact
// display (e.g. "Traditional · Luxe · Mini"). Empty if no camps.
export const formatCampShortList = (hotelSlug, campSlugs, lang = "en") => {
  const camps = getCampsForHotel(hotelSlug);
  return (campSlugs || [])
    .map((s) => {
      const camp = camps.find((c) => c.slug === s);
      return camp ? camp.short[lang] || camp.short.en || "" : "";
    })
    .filter(Boolean)
    .join(" · ");
};
